<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading" v-if="classHeadeDtls.data && classHeadeDtls.data.length>0">Classification History ({{classHeadeDtls.data.length}}) </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading" v-else>No Classification History found.</div>
      </div>
    <div class="row hr-thin"></div>

          <base-collapse>
            <div
              v-for="(classData, indexClsRD) in classHeadeDtls.data"
              v-bind:key="indexClsRD"
              class="mb-12px">
              <base-collapse-item class="class-summary notification_box hist-hdr"  :title="classData.class_code+','+classData.market+','+classData.product_name" :name="indexClsRD+'Rule-DT'">
                  <a href="javascript:void(0);" class="service" @click="routeProductClassificationRationale(classData)">
                <div class="row class_question">
                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">Classification Question</div>
                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">Response</div>
                </div>
                <div class="row class_question_summary p-t10-b10"  v-for="(dtlData, indexClsDD) in classData.details"      v-bind:key="indexClsDD">
                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7"><span v-html="dtlData.question"></span> </div>
                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">{{dtlData.response}}
                  </div>
                </div></a>
              </base-collapse-item>
            </div>
          </base-collapse>
      <loader :loadingStatus="loaderStatus"></loader>
      </div>
</template>
<script>
import Loader from '../UIComponents/Loader.vue';
import { getDetailsForSummaryPrint } from '../../apis/prodClassification';

import {
  getSubscribedPlans,
} from '../../apis/plans';
import BaseCollapse from '../Common/BaseCollapse.vue';
import BaseCollapseItem from '../Common/BaseCollapseItem.vue';

const DEFAULT_PLAN_ID = 10;
export default {
  components: {
    Loader,
    BaseCollapse,
    BaseCollapseItem,
  },
  props: [
    'userIdLoggedIn', 'userIdentity',
  ],
  async mounted() {
    this.loaderStatus = true;
    this.classHeadeDtls = await getDetailsForSummaryPrint(JSON.parse(localStorage.getItem('userData')).account_id);
    this.loaderStatus = false;
  },
  data() {
    return {
      threeDotsPermissionFlag: true,
      genericPopupId: 'genericPopupTeam',
      loaderStatus: false,
      downloadCounter: 1,
      max_dnld_allowed: 2,
      rationaleReqs: [],
      validationMsg: 'Please create some EU MDR classifications',
      filePath: 'faq/preview/',
      classHeadeDtls: [],
      prodClassCriteria: {
        source: 'classAltSrcOne',
        country: 'EU MDR',
        medical_device_type: 'GeneralMedicalDevice',
        device_name: null,
        ruleRefArray: [],
        levelArray: [],
        levelArrayVal: '',
        compositeArrayWrapper: {
          classFoundFlag: false,
          classNotes: '',
          classCode: '',
          classRuleRef: 3,
          dataArray: [],
        },
        headerId: '',
      },
      dropDownMenuDisable: false,
      changeClass: false,
    };
  },
  methods: {
    routeProductClassificationRationale(classData) {
      this.loaderStatus = true;
      this.prodClassCriteria.country = classData.market;
      this.prodClassCriteria.compositeArrayWrapper.classCode = classData.class_code;
      const levelArr = [];
      classData.details.forEach((element) => { levelArr.push(element.level); });
      this.prodClassCriteria.levelArray = levelArr;
      this.prodClassCriteria.device_name = classData.product_name;
      this.prodClassCriteria.headerId = classData.id;
      this.prodClassCriteria.previewMode = true;
      const params = {
        searchCriteria: this.prodClassCriteria,
        accountId: this.account_id,
        userId: this.userId,
      };
      this.$router.push({ name: 'ProductClassificationRationale', params });
      this.loaderStatus = false;
    },
    initiatePSMFlowFor(serviceId) {
      this.$router.push(`/layout/market-place/add-service/${serviceId}`);
    },
    async checkDefaultPlanSubscription() {
      let subscriptionStatus = false;
      let addedPlans = [];
      addedPlans = await getSubscribedPlans(JSON.parse(localStorage.getItem('userData')).account_id);
      for (let iter = 0; iter < addedPlans.length; iter += 1) {
        if (addedPlans[iter].id === DEFAULT_PLAN_ID) {
          subscriptionStatus = true;
          break;
        }
      }
      return subscriptionStatus;
    },
    routeClassificationSummary(rowObject) {
      this.prodClassCriteria.headerId = rowObject.header_id;
      const params = { searchCriteria: this.prodClassCriteria };
      this.$router.push({ name: 'ProdClassificationSummary', params });
    },
  },
  computed: {
    getCompositeMassgedDataObject() {
      const classRationalCompositeObjectFromRules = {};
      return classRationalCompositeObjectFromRules;
    },
    submitDataWatch() { return this.submitData; },
  },
};
</script>
<style scoped>
.heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #0B3C61;
}
.p-t10-b10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.notification_box {
  position: relative;
  display: block;
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding-left: 8px;
}
.class_question {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}
.hist-hdr {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
}
.class_question_summary {
  font-size: 15px;
  line-height: 23px;
}
.class-summary {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #00518a;
}
.mb-12px {
  margin-bottom: 8px;
}
</style>
